// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3EoQN","content":"LoadingAlert_content___MGRe"};